import { Link } from "react-router-dom";
import React from "react";

interface MenuLinkProps {
  to: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label?: React.ReactNode;
  onClose?: () => void;
  className?: string;
  targetBlank?: boolean;
  target?: string;
}

export default function MenuLink(props: MenuLinkProps) {
  const {
    to,
    icon: Icon,
    label,
    onClose,
    className = "flex items-center h-12 hover:bg-slate-gray-200 rounded pr-4 py-2 my-4",
    targetBlank = false,
    target
  } = props;

  const renderLabel = label;

  if (targetBlank) {
    return (
      <a
        href={to}
        target={target || "_blank"}
        rel="noopener noreferrer"
        onClick={onClose}
        className={className}
      >
        <Icon className="h-6 w-6" />
        <span className="ml-2 flex-1">{renderLabel}</span>
      </a>
    );
  }

  return (
    <Link to={to} onClick={onClose} className={`${className}`}>
      <Icon className="h-6 w-6" />
      <span className="ml-2 flex-1">{renderLabel}</span>
    </Link>
  );
}
